module.exports = __webpack_public_path__ + "img/Wallet-link.02683bd3.gif";